import React from 'react'
import { reduxForm } from 'redux-form'

import Dropzone from 'react-dropzone'
import DropzonePreview from '../forms/dropzone-preview'
import SingleAreaSelectContainer from '../../containers/forms/single-area-select-container'

import cx from 'classnames'
import { generateValidation } from 'redux-form-validation'
import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup,
  InlineCheckbox
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const validations = {
  areaId: { required: true },
  issueDescriptionId: { required: true },
  status: { required: true },
  notes: {},
  image: {}
}

const statuses = {
  needs_work: 'Attention Req.',
  needs_review: 'Unresolved',
  permanent: 'Permanent'
}

const IssueForm = ({
  fields: {
    status,
    areaId,
    notes,
    issueDescriptionId,
    image
  },
  selectedAreaIssueCount,
  newIssue,
  loading,
  issueDescriptions,
  error,
  submitting,
  location,
  handleSubmit,
  handleClose,
  modalTitle,
  viewIssuesClicked,
  submitButtonText
}) => {
  if (loading) return <p>Loading...</p>

  return (
    <BaseModal
      onClose={handleClose}
      title={modalTitle}
      constraints={constraints}
      contentClassName='issue-create-container'
    >
      <ModalForm onSubmit={handleSubmit} customClassName='issue-edit-form'>
        <ModalFormRow>
          <ModalFormBlock>
            {<p className={cx({'centered': true, 'error': true, hidden: !error || handleSubmit})}>
              {error && error.detail}
            </p>}
          </ModalFormBlock>
        </ModalFormRow>

        {newIssue &&
          <ModalFormRow>
            <ModalFormBlock customClassName={cx({ 'has-issues': selectedAreaIssueCount > 0 })}>
              <label htmlFor='areaId'>Area</label>
              <SingleAreaSelectContainer locationId={location.id} {...areaId} />
              {selectedAreaIssueCount > 0 && <button className='view-issues' onClick={() => {
                viewIssuesClicked(areaId.value)
              }}>Issues</button>}
            </ModalFormBlock>
          </ModalFormRow>
        }

        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='status'>status</label>
            <select {...status} value={status.value || ''}>
              <option disabled>Select</option>
              {Object.keys(statuses).map((statusKey) => (
                <option key={statusKey} value={statusKey}>
                  {statuses[statusKey]}
                </option>
              ))}
            </select>
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='description'>description</label>
            <select {...issueDescriptionId} value={issueDescriptionId.value || ''}>
              <option disabled>Select</option>
              {issueDescriptions.map(issueDescription => (
                <option key={issueDescription.id} value={issueDescription.id}>
                  {issueDescription.name}
                </option>
              ))}
            </select>
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock>
            <label>image</label>
            <Dropzone
              className='dropzone'
              activeClassName='active'
              multiple={false}
              onDrop={(files, e) => image.onChange(files[0])}
            >
              <DropzonePreview attribute={image} />
            </Dropzone>
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='notes'>notes</label>
            <textarea placeholder='Notes...' {...notes} />
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button disabled={submitting} type='submit'>
              {submitting ? 'Submitting...' : submitButtonText}
            </button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}

export default reduxForm({
  form: 'addEditIssue',
  ...generateValidation(validations)
})(IssueForm)



// WEBPACK FOOTER //
// ./src/components/issues/issue-form.js